<template>
  <v-card class="mx-auto pa-0" :height="maxHeight" width="1160" :color="customColor('cardColor')" @click="$emit('click')">
    <v-card-text>
      <v-row justify="center">
        <v-col cols="12" sm="2" md="2" align="center">
          <v-img height="100" width="100" :src="data.icon" contain></v-img>
        </v-col>
        <v-col cols="12" sm="7" md="8">
          <div class="pa-0 text-h6 text-truncate" :style="customColor('titleColor')">{{ data.name }}</div>
          <div class="text-truncate" :style="customColor('contentColor')">
            <v-icon>mdi-circle-medium</v-icon>{{ data.publisherName }} <v-icon>mdi-circle-medium</v-icon>{{ data.industryName }}
            <v-icon>mdi-circle-medium</v-icon>{{ data.typeName }} <v-icon>mdi-circle-medium</v-icon>{{ data.runtimeEnvironmentName }}
          </div>
          <v-rating
            class="mt-sm-6"
            :value="data.rating"
            :color="customColor('ratingColor')"
            :background-color="customColor('ratingColor')"
            dense
            half-increments
            readonly
            size="14"
          ></v-rating>
        </v-col>
        <v-col cols="12" sm="3" md="2" class="mt-sm-9">
          <div v-if="!discount.exist" class="mt-sm-10" :style="customColor('priceColor')">NT${{ data.price }}</div>
          <template v-else>
            <div :style="customColor('discountColor')">{{ discountPeriod }}</div>
            <div :style="customColor('discountColor')">NT${{ discount.price }}</div>
            <div class="text-decoration-line-through" :style="customColor('priceColor')">NT${{ data.price }}</div>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Product from '../store/product';

export default {
  name: 'CardList',
  props: {
    data: { type: Object, required: true },
    styleInfo: {
      type: Object,
      default: () => ({
        cardColor: 'white',
        titleColor: '#737373',
        contentColor: '#737373',
        ratingColor: '#737373',
        priceColor: '#007EAE',
        discountColor: 'red',
      }),
    },
  },
  data: () => ({
    discount: {},
  }),
  computed: {
    discountPeriod() {
      return Product.discountPeriod();
    },
    maxHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '320';
        default:
          return '130';
      }
    },
  },
  created() {
    this.discount = Product.discountProc(this.data.discountPeriod, this.data.discount);
  },
  methods: {
    customColor(type) {
      switch (type) {
        case 'cardColor':
        case 'ratingColor':
          return this.styleInfo[type];
        default:
          return `color: ${this.styleInfo[type]}`;
      }
    },
    price(price) {
      return Product.price(price);
    },
    unit(price) {
      return this.$t(Product.unit(price));
    },
  },
};
</script>
